<script>
	const _ = require('underscore');
	const Q = require('q');

	const model = require('model/model');
	const utilities = require('utilities');
	const classBOKUtilities = require('utilities/classBOKUtilities');
	const getClassBok = classBOKUtilities.get;
	const addToClassBoK = classBOKUtilities.create;
	const removeFromClassBoK = classBOKUtilities.remove;
	const editClassBokEntry = classBOKUtilities.edit;

	const classUtilities = require('utilities/classUtilities');
	const sortStudentsByName = classUtilities.sortStudentsByName;

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const CBOK_OPEN = analyticsUtilities.events.CBOK_OPEN;
	const CBOK_OPEN_SET = analyticsUtilities.events.CBOK_OPEN_SET;
	const CBOK_CLOSE_SET = analyticsUtilities.events.CBOK_CLOSE_SET;
	const CBOK_CLOSE_ALL_SETS = analyticsUtilities.events.CBOK_CLOSE_ALL_SETS;
	const CBOK_SORT = analyticsUtilities.events.CBOK_SORT;
	const CBOK_CREATE_ENTRY = analyticsUtilities.events.CBOK_CREATE_ENTRY;
	const CBOK_EDIT_ENTRY = analyticsUtilities.events.CBOK_EDIT_ENTRY;
	const CBOK_DELETE_ENTRY = analyticsUtilities.events.CBOK_DELETE_ENTRY;
	const CBOK_POST_STUDENT_ENTRY = analyticsUtilities.events.CBOK_POST_STUDENT_ENTRY;
	const CBOK_REMOVE_STUDENT_ENTRY = analyticsUtilities.events.CBOK_REMOVE_STUDENT_ENTRY;
	const PRINT = analyticsUtilities.events.PRINT;

	const { assetUrl } = require('utilities/urlUtilities');

	const teacherActionOptions = [
		{
			text: 'Edit',
			value: 'edit'
		},
		{
			text: 'Delete',
			value: 'del'
		}
	];

	const studentActionOptions = [
		{
			text: 'Remove',
			value: 'del'
		}
	];

	const sorts = {
		newest: (a, b) => b.startDate - a.startDate,
		oldest: (a, b) => a.startDate - b.startDate
	};

	module.exports = {
		components: {
			'book-of-knowledge-assignment': require('components/book-of-knowledge-assignment.vue').default,
			'book-of-knowledge-entry': require('components/book-of-knowledge-entry.vue').default,
			'bok-bookmark-icon': require('components/svg/bok-bookmark-icon.vue').default,
			'dropdown-button': require('components/dropdown-button.vue').default,
			'validated-textarea': require('components/validated-textarea.vue').default,
			'validated-form': require('components/validated-form.vue').default,
			'token-field': require('components/token-field.vue').default,
			'article-a-day-promo-content': require('components/routes/onboarding/article-a-day-promo-content.vue').default
		},
		props: ['assignments', 'roster', 'isLoading'],
		modelData: ['classBok', 'classCode', 'whiteboardView'],
		data() {
			return {
				expanded: {},
				loading: {},
				selectedAid: null,
				editEntry: null,
				editSuids: null,
				editContent: null,
				editArticleSelection: '',
				sort: 'newest'
			};
		},
		computed: {
			aadAssignments() {
				let assignments = this.assignments;
				let sort = this.sort || 'newest';
				let aads = [];

				if (assignments && assignments.length) {
					aads = assignments
						.filter(a => {
							return a.productMetaData && a.productMetaData.productType === 'AAD';
						})
						.sort(sorts[sort]);
				}

				return aads;
			},
			classBokPanels() {
				let aadAssignments = this.aadAssignments;
				let classBok = this.classBok || {};
				let roster = this.roster;
				let editEntry = this.editEntry;
				let panels = [];

				if (aadAssignments && aadAssignments.length && roster) {
					panels = aadAssignments.map(a => {
						let aid = a.assignmentId;
						let cbok = classBok[a.assignmentId] || {};
						let content = cbok && cbok.content ? cbok.content : [];
						let studentEntries = cbok && cbok.studentEntries ? cbok.studentEntries : [];
						let cbokEntriesById = {};
						let s = 's';
						const bokAssigned = a.options.assignBookOfKnowledge;

						let entries = content.reduce((acc, entry) => {
							let name = null;
							let suids = entry.suids;
							let editing = false;
							let stillEnrolled = false;

							if (suids.length) {
								suids.every(suid => {
									if (roster[suid]) {
										stillEnrolled = true;
										return false;
									}
									return true;
								});
							} else {
								stillEnrolled = true;
							}

							if (stillEnrolled) {
								name = this.generateNames(suids, roster);
								cbokEntriesById[entry.id] = entry;

								if (editEntry && editEntry.id === entry.id) {
									editing = true;
								}
								acc.push(
									_.assign({}, entry, {
										name,
										s,
										tf: entry.tf || entry.c,
										pid: entry.cpid,
										editing
									})
								);
							}
							return acc;
						}, []);

						studentEntries = studentEntries.reduce((acc, e) => {
							const articleData = a.productMetaData.allArticles[e.cpid];
							const isDecodable = !!(articleData && articleData.decodableTeacherEdition);

							if (bokAssigned && !!articleData && !isDecodable && roster[e.suid] && !cbokEntriesById[e.id]) {
								let name = this.generateNames([e.suid], roster);
								acc.push(
									_.assign({}, e, {
										name,
										s,
										tf: e.tf || e.c,
										pid: e.cpid
									})
								);
							}
							return acc;
						}, []);

						if (editEntry && editEntry.id === 'new' && editEntry.aid === aid) {
							let entry = _.assign({}, editEntry, {
								editing: true
							});
							entries = [entry].concat(entries);
						}
						return _.assign({}, a, {
							pmd: a.productMetaData,
							entries,
							assigned: true,
							d: a.startDate,
							ed: a.deadline,
							studentEntries
						});
					});
				}

				return panels;
			},
			selectedAssignment() {
				let aadAssignments = this.aadAssignments;
				let selectedAid = this.selectedAid;
				let assignment = null;

				if (aadAssignments && aadAssignments.length && selectedAid) {
					aadAssignments.every(a => {
						if (a.assignmentId === selectedAid) {
							assignment = a;
							return false;
						}
						return true;
					});
				}
				return assignment;
			},
			editArticles() {
				let editEntry = this.editEntry;
				let aadAssignments = this.aadAssignments;
				let articles = null;

				if (editEntry && aadAssignments && aadAssignments.length) {
					aadAssignments.every(aad => {
						if (aad.assignmentId === editEntry.aid) {
							articles = aad.productMetaData.articleList;
							return false;
						}
						return true;
					});
				}
				return articles;
			},
			editRoster() {
				let editSuids = this.editSuids || [];
				let roster = this.roster;
				let items = [];

				if (roster && editSuids) {
					let allSuids = Object.keys(roster);
					let selectedSuidMap = editSuids.reduce((acc, suid) => {
						acc[suid] = true;
						return acc;
					}, {});

					items = allSuids.map(suid => {
						let student = roster[suid];
						let name = student.firstName + (student.lastName ? ' ' + student.lastName : '');
						return _.assign({}, student, {
							id: suid,
							text: name,
							name,
							selected: selectedSuidMap[suid]
						});
					});
				}

				return items;
			},
			emptyCbok() {
				let isLoading = this.isLoading;
				let classBokPanels = this.classBokPanels;

				return !isLoading && (!classBokPanels || !classBokPanels.length);
			},
			printDisabled() {
				for (const panelId in this.expanded) {
					if (this.expanded[panelId] === true) {
						const activePanel = this.classBokPanels.find(({ assignmentId }) => assignmentId === panelId);
						if (activePanel && activePanel.entries.length > 0) {
							return false;
						}
					}
				}

				return true;
			},
			loaderImageSrc() {
				return assetUrl('/assets/dist/images/loader.gif');
			}
		},
		watch: {
			aadAssignments: {
				handler(aads) {
					if (aads && aads.length) {
						let firstAssignment = aads[0];
						let firstAid = firstAssignment.assignmentId;
						let classCode = this.classCode;
						if (firstAid) {
							this.fetchCBOK(firstAid, classCode);
						}
					}
				},
				immediate: true
			},
			classCode(value, oldValue) {
				if (oldValue) {
					fireEvent(CBOK_OPEN, {
						cc: value
					});
				}
			},
			sort(value, oldValue) {
				if (oldValue) {
					let cc = this.classCode;
					fireEvent(CBOK_SORT, {
						cc,
						sort: value
					});
				}
			}
		},
		methods: {
			fetchCBOK(aid) {
				let classCode = this.classCode;

				this.toggleLoading(aid, true);
				this.expanded = _.assign({}, this.expanded, {
					[aid]: true
				});
				this.selectedAssignment = null;

				return getClassBok(aid, classCode).then(() => delete this.loading[aid]);
			},
			onWhiteboardViewClick() {
				let whiteboardView = this.whiteboardView;
				model.set('whiteboardView', !whiteboardView);
			},
			toggleExpand(aid) {
				let cc = this.classCode;
				if (this.expanded[aid]) {
					let expanded = _.assign({}, this.expanded);
					expanded[aid] = false;
					this.expanded = expanded;
					this.selectedAid = null;

					fireEvent(CBOK_CLOSE_SET, {
						cc,
						aid
					});
				} else {
					fireEvent(CBOK_OPEN_SET, {
						cc,
						aid
					});
					this.fetchCBOK(aid);
				}
			},
			toggleLoading(aid, value) {
				let loading = this.loading;
				value = typeof value !== 'undefined' ? value : !loading[aid];
				this.loading = _.assign({}, loading, {
					[aid]: value
				});
			},
			collapseAll() {
				let cc = this.classCode;

				this.expanded = {};
				this.selectedAid = null;
				fireEvent(CBOK_CLOSE_ALL_SETS, {
					cc
				});
			},
			generateNames(suids, roster) {
				let name = 'Everyone';
				if (roster) {
					const studentNames = utilities.unambiguousStudentLabels(roster);
					const names = suids.reduce((acc, suid) => {
						let student = roster[suid];
						if (student && student.firstName) {
							acc.push(student);
						}
						return acc;
					}, []);

					if (names && names.length) {
						const nameCount = names.length;
						const hasMultiple = nameCount > 1;

						name = names.sort(sortStudentsByName).reduce((acc, student, index) => {
							const currentName = studentNames[student.uid];

							if (hasMultiple) {
								if (index < nameCount - 2) {
									return `${acc}${currentName}, `;
								}

								if (index === nameCount - 2) {
									return `${acc}${currentName} `;
								}

								return `${acc}and ${currentName}`;
							}

							return currentName;
						}, '');
					}
				}
				return name;
			},
			addExistingEntry(aid) {
				this.selectedAid = aid;
			},
			onDoneAddingClick() {
				this.selectedAid = null;
			},
			addToCbok(entry) {
				let aid = this.selectedAid;
				let cc = this.classCode;
				let suids = entry.suids;
				let a = entry.cpid;

				this.toggleLoading(aid, true);
				fireEvent(CBOK_POST_STUDENT_ENTRY, {
					cc,
					aid,
					suids,
					pid: a
				});
				addToClassBoK(aid, cc, suids, a, entry).finally(() => this.toggleLoading(aid, false));
			},
			removeFromCbok(entry) {
				let cc = this.classCode;
				let aid = entry.aid;
				let uid = entry.suid;
				let a = entry.cpid;
				let id = entry.id;

				return removeFromClassBoK(id, aid, a, cc, uid);
			},
			syncCbok(aid) {
				this.toggleLoading(aid, true);
				this.fetchCBOK(aid).finally(() => this.toggleLoading(aid, false));
			},
			getActionOptions(entry) {
				let options = [...teacherActionOptions];
				if (entry.suid) {
					options = [...studentActionOptions];
				}
				return options;
			},
			createNewEntry(aid) {
				this.editEntry = {
					id: 'new',
					suids: [],
					b: '',
					cpid: '',
					aid
				};
				this.onEditEntry(this.editEntry);
			},
			onEditEntry(entry) {
				this.editEntry = entry;
				this.editSuids = entry.suids;
				this.editContent = entry.b;
				this.editArticleSelection = entry.cpid;
			},
			onActionClick(menuItem, entry) {
				let cc = this.classCode;
				let aid = entry.aid;
				let uid = entry.suid;
				let a = entry.cpid;

				if (menuItem.value === 'del') {
					this.toggleLoading(aid, true);

					let eventName = CBOK_DELETE_ENTRY;
					if (uid) {
						eventName = CBOK_REMOVE_STUDENT_ENTRY;
					}
					fireEvent(eventName, {
						cc,
						aid,
						pid: a,
						suids: uid ? [uid] : entry.suids
					});

					this.removeFromCbok(entry).then(() => this.toggleLoading(aid, false));
				} else if (menuItem.value === 'edit') {
					this.onEditEntry(entry);
				}
			},
			onEndEdit() {
				this.editEntry = null;
				this.editSuids = null;
				this.editContent = null;
				this.editArticleSelection = '';
			},
			onEditSubmit() {
				let editEntry = this.editEntry;
				let editSuids = this.editSuids;
				let editArticleSelection = this.editArticleSelection;
				let editContent = this.editContent;
				let prms = Q();
				let aid = editEntry.aid;
				let id = editEntry.id;
				let cc = undefined;

				this.toggleLoading(aid, true);
				if (id === 'new' || editEntry.cpid !== this.editArticleSelection) {
					// Article has changed
					if (id !== 'new') {
						fireEvent(CBOK_EDIT_ENTRY, {
							cc,
							aid,
							pid: editArticleSelection,
							suids: editSuids
						});
						prms = this.removeFromCbok(editEntry);
					} else {
						fireEvent(CBOK_CREATE_ENTRY, {
							cc,
							aid,
							pid: editArticleSelection,
							suids: editSuids
						});
					}
					prms = prms.then(() => {
						return addToClassBoK(aid, cc, editSuids, editArticleSelection, editEntry, editContent);
					});
				} else {
					fireEvent(CBOK_EDIT_ENTRY, {
						cc,
						aid,
						pid: editArticleSelection,
						suids: editSuids
					});
					prms = editClassBokEntry(id, aid, editSuids, editArticleSelection, editContent);
				}

				this.onEndEdit();

				return prms.then(() => this.toggleLoading(aid, false));
			},
			onEditStudentRemove(student) {
				if (student && student.uid) {
					let editSuids = [...this.editSuids];
					editSuids = editSuids.filter(s => student.uid !== s);
					this.editSuids = editSuids;
				}
			},
			onEditStudentAdd(student) {
				if (student && student.uid) {
					let editSuids = [...this.editSuids];
					editSuids.push(student.uid);
					this.editSuids = editSuids;
				}
			},
			onPrintClick() {
				fireEvent(PRINT, {
					section: 'CBOK',
					cc: this.classCode
				});

				window.print();
			}
		},
		mounted() {
			let cc = this.classCode;
			fireEvent(CBOK_OPEN, {
				cc
			});
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.main.class-bok {
		.cbok-header {
			display: flex;
			align-items: center;

			h2 {
				flex: 1;
			}
		}

		.cbok-filters {
			display: flex;
			align-items: center;

			.collapse {
				flex: 1;
				text-align: right;

				.collapse-link {
					color: $c-slate-muted;

					&:hover,
					&:focus {
						color: $c-slate-dark;
						text-decoration: underline;
						cursor: pointer;
					}
				}
			}
		}

		.cbok-panel {
			position: relative;

			button.expand-button {
				position: absolute;
				top: 1.5rem;
				right: 1rem;
				border-radius: 1rem;
				height: 2rem;
				width: 2rem;
				padding: 0;
			}

			.loading-container {
				display: none;
			}

			.cbok-panel-buttons {
				display: none;

				> button {
					margin-right: 1rem;
					margin-bottom: 0.5rem;
				}
			}

			.cbok-list.bok-assignment {
				border-top: none;
				padding-top: 0;
			}

			&.expanded {
				margin-bottom: 2rem;

				.bok-assignment {
					.assignment-date .entry-count {
						display: inline;
					}

					.card-container {
						display: block;
					}
				}

				.cbok-panel-buttons {
					display: block;
				}

				&.loading {
					.loading-container {
						display: flex;
					}
				}
			}

			.bok-assignment {
				padding-bottom: 0;

				.bok-assignment-header .assignment-meta {
					margin-right: 3rem;
				}

				.assignment-date .entry-count {
					display: none;
				}

				.card-container {
					display: none;
				}

				.bok-entry {
					padding-top: 0;

					.student-name {
						margin-top: 1rem;
					}

					.bok-actions {
						margin: 0.5rem 0.25rem 0 0;

						svg {
							cursor: pointer;

							&:hover g {
								stroke: $c-blue-dark;
							}
						}
					}

					&.teacher-edit.validated-form {
						width: 100%;
						padding: 1rem;
						background-color: $c-blue-notif;

						> * {
							margin-bottom: 0.25rem;
						}

						.edit-toolbar {
							text-align: right;

							.save-notif,
							.cancel-notif {
								padding: 0.25rem 0.5rem;
							}

							.cancel-notif {
								background-color: $c-grey;
								color: $c-slate-dark;
								border-color: $c-grey;
							}
						}

						.validated-textarea {
							textarea.validated-input {
								border: none;
								border-radius: 4px;
							}
						}

						.select-container {
							margin-bottom: 0;
							border: none;
							border-radius: 4px;

							.input-select {
								border-width: 0px;

								select {
									height: auto;
									border: none;
									margin: 0;
								}

								&:after {
									z-index: 2;
								}
							}
						}
					}
				}
			}
		}

		.cbok-drawer {
			margin: 1rem 0;
			border-top: none;

			.cbok-drawer-content {
				background-color: $c-slate-dark;
				padding: 1rem;
				border-radius: 4px;
				color: $c-white;

				.cbok-drawer-tools {
					> * {
						margin-right: 1rem;
					}

					.cbok-drawer-icon {
						display: flex;
						align-items: center;
						justify-content: center;
						margin: 0.5rem;
						height: 2rem;
						width: 2rem;
						border-radius: 1rem;
						background-color: $c-blue-lighter;
						color: $c-slate-dark;
					}

					.cbok-drawer-instructions {
						display: flex;
						align-items: center;
						flex: 1;

						.cbok-drawer-instructions-text {
							max-width: 20rem;
						}
					}

					.cbok-drawer-actions {
						display: flex;
						justify-content: flex-end;
						align-items: center;
						margin-top: 0.5rem;

						i.fa-solid {
							color: $c-green-bright;
						}

						.cbok-drawer-sync {
							margin-right: 2rem;
						}
					}
				}

				.cbok-drawer-no-entries {
					margin: 1rem 0;
					font-style: italic;
				}

				.card-container {
					margin-top: 1rem;
					max-height: 25rem;
					overflow-y: scroll;

					.bok-entry {
						margin-right: 0.5rem;
					}
				}
			}
		}

		.select-container {
			.label {
				font-size: 0.75rem;
			}

			.input-select.slim {
				min-width: 7.5rem;
				display: block;
			}
		}

		.loading-container {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: rgba(255, 255, 255, 0.6);

			.loading-plaque {
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0.5rem;
				border-radius: 4px;
				background-color: white;

				.loading-indicator {
					display: inline-block;
					margin-right: 0.5rem;
				}
			}
		}

		.learn-aad {
			font-style: italic;
		}
	}

	.button-dark {
		padding: 0.5rem 1rem;
		border: none;
		border-radius: 4px;
		background-color: $c-slate-dark;
		color: $c-white;

		&:hover {
			background-color: $c-white;
			color: $c-slate-dark;
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.main.class-bok {
			.cbok-panel {
				.bok-assignment {
					padding-bottom: 0;

					.bok-assignment-header .assignment-meta {
						margin-right: 3rem;
					}
				}

				.cbok-drawer .cbok-drawer-content .cbok-drawer-tools {
					display: flex;
					align-items: center;

					.cbok-drawer-actions {
						margin-top: 0.5rem;
					}
				}
			}
		}
	}

	@media print {
		.main.class-bok .cbok-panel.expanded {
			margin-bottom: 0;
		}
	}
</style>
<template>
	<main class="main class-bok">
		<div class="cbok-header">
			<h2>Class Book of Knowledge</h2>
			<div class="cbok-header-actions print-hidden">
				<button
					v-if="!whiteboardView"
					class="print-button button -small blue-outline tooltip-bottom"
					v-tooltip="'Print'"
					:disabled="printDisabled"
					@click="onPrintClick">
					<i class="fa-solid fa-lg fa-print"></i>
				</button>
				<button
					v-if="!emptyCbok"
					class="whiteboard-button button -small blue-outline tooltip-bottom"
					v-tooltip="whiteboardView ? 'Exit Whiteboard/Projector view' : 'Enter Whiteboard/Projector view'"
					@click="onWhiteboardViewClick">
					<i
						class="fa-solid fa-lg"
						:class="{
							'fa-xmark': whiteboardView,
							'fa-desktop': !whiteboardView
						}"></i>
				</button>
			</div>
		</div>
		<div
			v-if="!emptyCbok"
			class="cbok-filters form print-hidden">
			<div class="select-container">
				<label class="label">Sort by:</label>
				<div class="input-select slim">
					<select v-model="sort">
						<option
							value="newest"
							selected>
							Newest
						</option>
						<option value="oldest">Oldest</option>
					</select>
				</div>
			</div>
			<div class="collapse">
				<button
					class="button -link collapse-link"
					@click="collapseAll">
					Collapse All
				</button>
			</div>
		</div>
		<template v-if="!isLoading && classBokPanels && classBokPanels.length">
			<div
				v-for="panel in classBokPanels"
				:key="panel.assignmentId"
				class="cbok-panel"
				:class="{
					expanded: expanded[panel.assignmentId],
					'print-hidden': !expanded[panel.assignmentId] || panel.entries.length === 0,
					loading: loading[panel.assignmentId]
				}">
				<button
					class="button expand-button"
					@click="toggleExpand(panel.assignmentId)"
					:aria-label="expanded[panel.assignmentId] ? 'Collapse' : 'Expand'">
					<i
						class="fa-solid"
						:class="{
							'fa-chevron-down': !expanded[panel.assignmentId],
							'fa-chevron-up': expanded[panel.assignmentId]
						}"
						aria-hidden="true"></i>
				</button>
				<book-of-knowledge-assignment :assignment="panel"> </book-of-knowledge-assignment>
				<div class="cbok-list bok-assignment">
					<div class="card-container">
						<template v-for="entry in panel.entries">
							<book-of-knowledge-entry
								v-if="!entry.editing"
								:entry="entry"
								:article="panel.pmd.allArticles && panel.pmd.allArticles[entry.pid]">
								<dropdown-button
									slot="actions"
									@click-item="onActionClick"
									:items="getActionOptions(entry)"
									:data-item="entry"></dropdown-button>
							</book-of-knowledge-entry>
							<validated-form
								v-if="entry.editing"
								class="teacher-edit bok-entry print-hidden"
								:on-submit="onEditSubmit">
								<token-field
									:items="editRoster"
									:on-token-click="onEditStudentRemove"
									:on-suggestion-click="onEditStudentAdd"
									placeholder="Add students (optional)..."></token-field>
								<validated-textarea
									class="print-hidden"
									:value="editContent"
									@input.native="editContent = $event.target.value"
									placeholder="What did we learn?"
									required>
								</validated-textarea>
								<div class="select-container">
									<label class="label">from</label>
									<div class="input-select slim">
										<select
											v-model="editArticleSelection"
											required>
											<option
												disabled
												value="">
												Select Article
											</option>
											<option
												v-for="article in editArticles"
												:key="article.uuid"
												:value="article.uuid">
												{{ article.title }}
											</option>
										</select>
									</div>
								</div>
								<div class="edit-toolbar">
									<button
										class="cancel-notif button"
										type="button"
										@click="onEndEdit">
										Cancel
									</button>
									<button
										class="save-notif button"
										type="submit">
										Save
									</button>
								</div>
							</validated-form>
						</template>
					</div>
				</div>
				<div class="loading-container">
					<span class="loading-plaque">
						<img
							:src="loaderImageSrc"
							class="loading-indicator"
							alt="Loading"
							role="presentation" />
						Loading...
					</span>
				</div>
				<div class="cbok-panel-buttons">
					<button
						class="button"
						:class="{
							disabled: loading[panel.assignmentId]
						}"
						:disabled="loading[panel.assignmentId]"
						@click="createNewEntry(panel.assignmentId)">
						+ Write New Entry
					</button>
					<button
						v-if="!loading[panel.assignmentId] && panel.studentEntries.length"
						class="button"
						@click="addExistingEntry(panel.assignmentId)">
						+ Post Student Entry
					</button>
					<button
						v-if="loading[panel.assignmentId] || !panel.studentEntries.length"
						v-tooltip="'There are no student Book of Knowledge entries that can be posted.'"
						class="button disabled">
						+ Post Student Entry
					</button>
				</div>
				<div
					class="cbok-drawer bok-assignment print-hidden"
					v-if="selectedAssignment && selectedAssignment.assignmentId === panel.assignmentId">
					<div class="cbok-drawer-content">
						<div class="cbok-drawer-tools">
							<div class="cbok-drawer-instructions">
								<div class="cbok-drawer-icon">
									<bok-bookmark-icon></bok-bookmark-icon>
								</div>
								<div class="cbok-drawer-instructions-text">Click the book icon on an entry to add it to the Class Book of Knowledge.</div>
							</div>
							<div class="cbok-drawer-actions">
								<button
									class="button button-dark cbok-drawer-sync"
									@click="syncCbok(selectedAssignment.assignmentId)">
									Refresh
									<i
										class="fa-solid fa-rotate"
										aria-hidden="true"></i>
								</button>
								<button
									class="button button-dark cbok-drawer-done"
									@click="onDoneAddingClick">
									Done
									<i
										class="fa-solid fa-check"
										aria-hidden="true"></i>
								</button>
							</div>
						</div>
						<div
							class="cbok-drawer-no-entries"
							v-if="!panel.studentEntries.length">
							There are no entries eligible for the Class Book of Knowledge at this time.
						</div>
						<div class="card-container">
							<book-of-knowledge-entry
								v-for="entry in panel.studentEntries"
								:key="entry.uid"
								:entry="entry"
								:article="panel.pmd.allArticles && panel.pmd.allArticles[entry.pid]"
								:assigned="panel.assigned">
								<button
									slot="actions"
									class="button -link"
									@click="addToCbok(entry)">
									<bok-bookmark-icon></bok-bookmark-icon>
								</button>
							</book-of-knowledge-entry>
						</div>
					</div>
				</div>
			</div>
		</template>
		<div
			v-if="emptyCbok"
			class="no-aad-assignments">
			<p class="learn-aad">To create a Class Book of Knowledge, you first need to start assigning Article-A-Day Sets to your class. Learn more below.</p>
			<article-a-day-promo-content> </article-a-day-promo-content>
		</div>
		<div
			v-if="isLoading"
			class="loading-container">
			<span class="loading-plaque">
				<img
					:src="loaderImageSrc"
					class="loading-indicator"
					aria-hidden="true" />
				Loading...
			</span>
		</div>
	</main>
</template>
